// Vue « Décoder un panic iPhone ». Colle/importe un .ips → résumé + pistes
// board-level, avec un raccourci pour lancer un diagnostic pré-rempli.

import { decodePanic, type PanicReport } from "../diagnostic/panic";
import { el, esc, toast } from "./dom";

export interface PanicPrefill {
  symptom: string;
  device_model: string | null;
  device_brand: string;
}

export function renderPanicView(host: HTMLElement, onDiagnose: (p: PanicPrefill) => void): void {
  host.innerHTML = "";
  const card = el(`
    <section class="card">
      <h2>Décoder un panic iPhone</h2>
      <p class="muted">Colle un fichier .ips (Réglages → Confidentialité → Analyse &amp; améliorations → Données d'analyse) ou importe-le.</p>
      <textarea id="pk-in" rows="6" placeholder="Colle ici le contenu du panic (.ips / panic-full)…"></textarea>
      <div style="display:flex;gap:8px;margin-top:12px;">
        <button class="btn sm" id="pk-decode">Décoder</button>
        <button class="btn sm ghost" id="pk-file">Importer .ips</button>
      </div>
      <div id="pk-out"></div>
    </section>`);
  host.appendChild(card);

  const ta = card.querySelector("#pk-in") as HTMLTextAreaElement;
  const out = card.querySelector("#pk-out") as HTMLElement;

  const decode = (text: string) => {
    const rep = decodePanic(text);
    if (!rep) {
      out.innerHTML = "";
      return toast("Rien à décoder.");
    }
    renderReport(out, rep, onDiagnose);
  };

  card.querySelector("#pk-decode")!.addEventListener("click", () => decode(ta.value));
  card.querySelector("#pk-file")!.addEventListener("click", () => {
    const inp = document.createElement("input");
    inp.type = "file";
    inp.accept = ".ips,.txt,.json,application/json";
    inp.addEventListener("change", async () => {
      const f = inp.files?.[0];
      if (!f) return;
      ta.value = await f.text();
      decode(ta.value);
    });
    inp.click();
  });
}

function renderReport(out: HTMLElement, rep: PanicReport, onDiagnose: (p: PanicPrefill) => void): void {
  const model = rep.productName ? `${rep.productName} (${rep.product})` : (rep.product ?? "modèle inconnu");
  const hints = rep.hints.length
    ? rep.hints
        .map(
          (h) => `<div class="cause">
            <div class="head"><strong>${esc(h.subsystem)}</strong><span class="src ${h.domaine === "power" ? "local" : "core"}">${esc(h.domaine)}</span></div>
            <div class="proc">${esc(h.piste)}</div>
          </div>`,
        )
        .join("")
    : `<p class="empty-note">Aucune signature connue dans ce panic. Le texte reste consultable ci-dessous.</p>`;

  out.innerHTML = `
    <div style="margin-top:14px;">
      <table class="kv">
        <tr><th>Appareil</th><td>${esc(model)}</td></tr>
        <tr><th>OS</th><td>${esc(rep.osVersion ?? "—")}</td></tr>
        <tr><th>Type</th><td>${esc(rep.bugType ?? "—")}</td></tr>
      </table>
      <h2 style="margin-top:14px;font-size:13px;text-transform:uppercase;letter-spacing:1px;color:var(--ink-dim);">Pistes board-level</h2>
      ${hints}
      <details style="margin-top:12px;"><summary class="muted">Voir la chaîne de panic brute</summary>
        <pre class="panic-raw">${esc(rep.panicString)}</pre></details>
      <button class="btn" id="pk-diag" style="margin-top:14px;">🔍 Diagnostiquer à partir de ce panic</button>
    </div>`;

  out.querySelector("#pk-diag")!.addEventListener("click", () => {
    const symptom = rep.hints.length
      ? `${rep.hints[0].subsystem} — panic iPhone`
      : `Panic iPhone : ${rep.panicString.split("\n")[0].slice(0, 80)}`;
    onDiagnose({ symptom, device_model: rep.productName ?? rep.product, device_brand: "Apple" });
  });
}
